import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/settings/chairmanSetup/main"));

const Chairman = () => {
  return (
      <Suspense fallback={<PageSkeleton />}>
        <Main />
      </Suspense>
  );
};

export default Chairman;
